import React, { useState, useMemo, useCallback, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  getPostCategories,
  getPostTags,
  getPosts,
} from "../../services/newsRequestServices";
import HtmlContent from "../../components/general/misc/HtmlContent";
import InfiniteScroll from "react-infinite-scroller";
import NewsAvatar from "../../components/general/misc/NewsAvatar";
import styled from "styled-components";
import variables from "../../assets/js/variables";
import { Pagination } from "@mui/material";

const { colors, gridBreakpoints } = variables;

const MyPagination = styled(Pagination)({
  "& .MuiPaginationItem-root": {
    color: "white",
  },
});

const News = () => {
  function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();
  const categoryId = +query.get("category");
  const tagId = +query.get("tag");

  const [categoryAndTagData, setCategoryAndTagData] = useState([]);
  const [newsData, setNewsData] = useState({ hasMore: true, items: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const getNewsData = useCallback(
    (page, append) => {
      getPosts(categoryId, tagId, page).then(({ next, results }) =>
        setNewsData((prevData) => ({
          hasMore: next !== null,
          items: append ? [...prevData.items, ...results] : results,
        }))
      );
    },
    [categoryId, tagId]
  );

  const getInitialNewsData = useCallback(() => {
    getNewsData(1, false);
  }, [getNewsData]);

  const getNextNewsData = useCallback(() => {
    if (!newsData.hasMore) return;
    getNewsData(currentPage + 1, true);
  }, [newsData.hasMore, currentPage, getNewsData]);

  const getCategoryData = useCallback(async () => {
    const { results: categories } = await getPostCategories();
    const { results: tags } = await getPostTags();
    setCategoryAndTagData([
      { id: null, title: "همه‌", type: "default" },
      ...categories.map((x) => ({ ...x, type: "category" })),
      ...tags.map((x) => ({ ...x, type: "tag" })),
    ]);
  }, []);
  useEffect(() => {
    getCategoryData();
    getInitialNewsData();
    setCurrentPage(1);
  }, [getCategoryData, getInitialNewsData]);

  const currentBlogContent = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return newsData.items.slice(startIndex, endIndex);
  }, [currentPage, newsData.items]);
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  // scrolltoTop
  const handlePageChange = (event, value) => {
    scrollTop();
    setCurrentPage(value);
  };

  let tagTitleData = [];
  let categoryTitleData = [];
  categoryAndTagData.forEach((item) => {
    if (item.type === "category") {
      categoryTitleData.push(item);
    } else if (item.type === "tag") {
      tagTitleData.push(item);
    } else {
      categoryTitleData.push(item);
      tagTitleData.push(item);
    }
  });
  let category = localStorage.getItem("category");
  let tag = localStorage.getItem("tag");
  console.log(category);
  console.log(tag);
  return (
    <Styles className="d-flex flex-column align-items-center justify-content-center">
      <TitleRow className="d-flex align-items-center w-100 mb-5">
        <div className="header-news">
          <h3 style={{ marginLeft: "1rem" }}>فهرست</h3>
          <div className="main-header">
            {categoryTitleData?.length ? (
              <div className="content-header border-b">
                <h5 className="title-tabs ">دسته</h5>
                <ButtonGroup>
                  <div className="wrapper">
                    {categoryTitleData.map((item) => {
                      return (
                        <Link
                          onClick={() => {
                            if (item.type === "default") {
                              localStorage.setItem("category", "");
                            } else {
                              localStorage.setItem(
                                "category",
                                `${item.type}=${item.id}`
                              );
                            }
                          }}
                          key={`${item.type}_${item.id}`}
                          to={
                            item.type === "default"
                              ? `/news/?${tag}`
                              : `/news/${`?category=${item.id}&${tag}`}`
                          }
                          className={`btn px-3 text-12 ${
                            (item.type === "category" &&
                              categoryId === item.id) ||
                            (item.type === "default" && categoryId === 0)
                              ? "active-tab"
                              : "border-green text-green"
                          } border-green text-green border-radius-8 
                          `}
                        >
                          {item.title}
                        </Link>
                      );
                    })}
                  </div>
                </ButtonGroup>
              </div>
            ) : null}
            {tagTitleData?.length ? (
              <div className="content-header">
                <h5 className="title-tabs ">برچسب</h5>
                <ButtonGroup>
                  <div className="wrapper">
                    {tagTitleData.map((item) => {
                      return (
                        <Link
                          onClick={() => {
                            if (item.type === "default") {
                              localStorage.setItem("tag", "");
                            } else {
                              localStorage.setItem(
                                "tag",
                                `${item.type}=${item.id}`
                              );
                            }
                          }}
                          key={`${item.type}_${item.id}`}
                          to={
                            item.type === "default"
                              ? `/news/?${category}`
                              : `/news/${`?${category}&${item.type}=${item.id}`}`
                          }
                          className={`btn px-3 text-12 ${
                            (item.type === "tag" && tagId === item.id) ||
                            (item.type === "default" && tagId === 0)
                              ? "active-tab"
                              : "border-green text-green"
                          } border-green text-green border-radius-8x`}
                        >
                          {item.title}
                        </Link>
                      );
                    })}
                  </div>
                </ButtonGroup>
              </div>
            ) : null}
          </div>
        </div>
      </TitleRow>
      {categoryAndTagData.length && (
        <InfiniteScroll
          initialLoad={false}
          loadMore={getNextNewsData}
          hasMore={newsData.hasMore}
        >
          <NewsList className="d-grid">
            {currentBlogContent.map((item) => (
              <NewsItem key={item.id} className="d-flex flex-row">
                <NewsAvatar
                  className="ms-4"
                  size={95}
                  photo={item.icon}
                  alt={item.title}
                />
                <NewsContent className="d-flex flex-column ">
                  <Link
                    to={`/news/?category=${item.category.id}`}
                    className="text-12 text-green mb-2"
                  >
                    {item.category.title}
                  </Link>
                  <h3 className="text-16 text-white mb-2">{item.title}</h3>
                  <div className="text-14 text-white mb-3">
                    <HtmlContent rawHtml={item.abs_content} />
                  </div>
                  <Link
                    to={`/news/${item.id}`}
                    className="text-green text-14 mb-4"
                  >
                    بیشتر بدانید
                  </Link>
                </NewsContent>
              </NewsItem>
            ))}
          </NewsList>
        </InfiniteScroll>
      )}
      {newsData.items.length ? (
        <span className="Pagination-news">
          <MyPagination
            count={Math.ceil(newsData.items.length / itemsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </span>
      ) : (
        <></>
      )}
    </Styles>
  );
};

export default News;

const Styles = styled.div`
  .css-yuzg60-MuiButtonBase-root-MuiPaginationItem-root {
    background-color: ${colors.whiteSmoke};
    :hover {
      background-color: ${colors.text};
    }
  }
  .css-yuzg60-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {
    background-color: ${colors.green};
    :hover {
      background-color: ${colors.green};
    }
  }
  .Pagination-news {
    margin-top: 20px;
  }
  .active-tab {
    background: ${colors.green} !important;
    color: ${colors.darkBlue} !important;
  }

  .header-news {
    display: flex;
    align-items: center;

    @media (max-width: 600px) {
      align-items: flex-start;

      flex-direction: column;
    }
    .main-header {
      display: flex;
      flex-direction: column;
    }
    .content-header {
      display: flex;
      align-items: center;
      @media (max-width: 600px) {
        align-items: flex-start;
        flex-direction: column;
        margin: 10px 0;
      }
    }
    .title-tabs {
      background: ${colors.background};
      padding: 4px 0;
      border-radius: 8px;
      height: fit-content;
      min-width: 100px;
      max-width: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin: 0 !important;
      @media (max-width: 600px) {
        margin-bottom: 10px;
      }
    }
    h5,
    h3 {
      color: ${colors.text};
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .border-b {
    border-bottom: 1px solid ${colors.green};
  }
`;

const TitleRow = styled.div`
  background-color: ${colors.darkBlue};
  padding: 5px 6rem;
  justify-content: space-between;

  @media (max-width: ${gridBreakpoints.md}px) {
    padding: 1rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  margin: 5px;
  .wrapper {
    a {
      margin: 0.25rem;
    }
  }
`;

const NewsList = styled.div`
  position: relative;
  margin: 3rem 6rem 0;
  gap: 1.5rem;

  @media (max-width: ${gridBreakpoints.md}px) {
    grid-template-columns: 1fr;
    margin: 1.5rem 1.5rem 0;
  }

  /* @media (min-width: ${gridBreakpoints.md +
  1}px) and (max-width: ${gridBreakpoints.xl}px) { */
  @media (min-width: ${gridBreakpoints.md}px) and (max-width: ${gridBreakpoints.xl}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${gridBreakpoints.xl + 1}px) {
    grid-template-columns: repeat(3, 1fr);
  }

  &:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 1.5rem;
    content: "";
    display: block;
    border: solid 1px ${colors.background};
  }
`;

const NewsItem = styled.div`
  line-height: 24px !important;
  height: 285px;
  border-bottom: solid 1px ${colors.brand};

  h3 {
    line-height: 1.8;
  }

  div {
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
    line-height: 1.8;
  }
`;

const NewsContent = styled.div`
  height: inherit;

  a {
    width: fit-content;
    border-bottom: solid 1px transparent;
    &:hover {
      border-bottom-color: inherit;
    }
  }
`;
